import React from 'react';
import './CookiePolicy.css';

const CookiePolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-header">
        <div className="container">
          <h1>Cookie Policy</h1>
          <p>Last updated: April 27, 2026</p>
        </div>
      </div>

      <div className="container policy-content my-5">
        <p className="intro">
          This Cookie Policy explains how Thrive Insurance Brokers Limited ("Thrive", "we", "us", or "our") uses cookies and similar tracking technologies when you interact with our website and online services.
        </p>

        <section>
          <h2>Scope of This Policy</h2>
          <p>
            This policy applies to all visitors and users of our website for insurance brokerage services. It explains the types of cookies we use, the purposes for which they are used, and how you can manage your cookie preferences.
          </p>
        </section>

        <section>
          <h2>What Are Cookies?</h2>
          <p>
            Cookies are small text files saved to your device by your browser when you visit a website. They help the website remember information about your visit, such as your language preferences, login status, and interactions with the site.
          </p>
        </section>

        <section>
          <h2>How We Use Cookies</h2>
          <p>
            We use cookies to provide, secure, and improve our website experience and insurance brokerage services. Cookies enable us to:
          </p>
          <ul>
            <li>Maintain session state and keep your browsing session active as you navigate the website.</li>
            <li>Store your cookie consent preferences (thriveCookieConsent and thriveCookiePreferences) to respect your privacy choices.</li>
            <li>Remember your language and display preferences for a better browsing experience.</li>
            <li>Analyze how visitors use our website, including pages visited, time spent, and navigation patterns, to improve our services.</li>
            <li>Track the effectiveness of our website features and content to optimize user experience.</li>
            <li>Measure the performance of contact forms, newsletter subscriptions, and claim submissions.</li>
            <li>Deliver relevant content and insurance product information based on your browsing behavior.</li>
            <li>Prevent fraud and maintain website security.</li>
          </ul>
        </section>

        <section>
          <h2>Types of Cookies We Use</h2>
          <ul>
            <li>
              <strong>Essential/Session Cookies:</strong> Required for the website to function correctly. These cookies support navigation, maintain your browsing session, and enable core functionality like form submissions and page transitions. Example: session cookies that keep you logged into the website.
            </li>
            <li>
              <strong>Consent Cookies:</strong> These store your cookie preferences and consent decisions (thriveCookieConsent and thriveCookiePreferences) so we respect your privacy choices on future visits.
            </li>
            <li>
              <strong>Performance and Analytics Cookies:</strong> These cookies collect anonymized information about how visitors use our site, including pages visited, user flows, time spent on pages, and browser/device information. We use this data to identify usage patterns, optimize website performance, and improve our services. These cookies help us understand which insurance products are most viewed and which pages need improvement.
            </li>
            <li>
              <strong>Functional Cookies:</strong> These cookies remember your choices and preferences, such as language selection, form field values, and navigation preferences, to make your next visit easier and more personalized.
            </li>
            <li>
              <strong>Advertising and Marketing Cookies:</strong> These cookies help us deliver relevant content and information about insurance products based on your browsing behavior and interests. They may also measure the effectiveness of our marketing content and campaigns.
            </li>
          </ul>
        </section>

        <section>
          <h2>How Long Cookies Last</h2>
          <p>
            Some cookies are deleted when you close your browser (session cookies). Others remain on your device for a longer period (persistent cookies) until they expire or you delete them.
          </p>
        </section>

        <section>
          <h2>Third-Party Cookies</h2>
          <p>
            Some cookies used on our site are set by trusted third-party partners, including analytics providers, advertising networks, and social media platforms. These partners may collect information about your browsing activity across different websites.
          </p>
          <p>
            We do not control third-party cookies. Please review the privacy and cookie policies of these third parties to understand how they use your data.
          </p>
        </section>

        <section>
          <h2>Managing Cookies</h2>
          <p>
            You may choose to accept, decline, or delete cookies through your browser settings. You can also block cookies from specific websites. Please note that disabling certain cookies may impact the functionality and performance of our website.
          </p>
          <p>
            To control advertising cookies, you can use tools provided by advertising networks or browser privacy settings to opt out of targeted advertising.
          </p>
        </section>

        <section>
          <h2>Cookies and Personal Data</h2>
          <p>
            Most cookies we use do not directly identify you personally. However, some cookies may be linked to personal information you voluntarily provide when you:
          </p>
          <ul>
            <li>Submit the contact form (providing name, email, phone, message)</li>
            <li>Subscribe to the newsletter (providing email)</li>
            <li>Report a claim (providing insured name, policy number, email, phone, and documents)</li>
            <li>Interact with forms on our website</li>
          </ul>
          <p>
            When we combine cookies with this personal information, cookies help us:
          </p>
          <ul>
            <li>Maintain your session state while you fill out and submit forms.</li>
            <li>Remember your contact information if you have previously submitted a form, to speed up future submissions.</li>
            <li>Track which insurance products or pages you viewed before filling out a contact or claim form.</li>
            <li>Link your browsing behavior to the inquiries or claims you submit, to better understand your insurance needs.</li>
            <li>Remember your newsletter subscription preferences and email for managing your subscription status.</li>
          </ul>
        </section>

        <section>
          <h2>Policy Updates</h2>
          <p>
            We may update this Cookie Policy periodically to reflect changes in our practices or legal requirements. When we make material changes, we will post the updated policy on this page and revise the "Last updated" date.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Cookie Policy or would like help managing your cookie settings, please visit our <a href="/contact">Contact Us</a> page.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;